const firebaseConfigObj= {
    apiKey: "AIzaSyD5yBrqxvZVev5o4kmoF14ula0zLPHeGzU",
    authDomain: "tic-tac-toe-64d60.firebaseapp.com",
    databaseURL: "https://tic-tac-toe-64d60.firebaseio.com",
    projectId: "tic-tac-toe-64d60",
    storageBucket: "tic-tac-toe-64d60.appspot.com",
    messagingSenderId: "59583445909",
    appId: "1:59583445909:web:3a5ad8d7c43d06ac34d49c",
    measurementId: "G-WYQDTK76BZ"
  }

export default firebaseConfigObj